'use client'

import { ReactNode } from 'react'
import ErrorPageComponent from '@/app/_components/ErrorPage/ErrorPageComponent'

/**
 * App-wide 404 page.
 *
 * Handles unmatched routes and any `notFound()` call that isn't caught by a closer
 * `not-found.tsx`. Renders the default `ErrorPage` copy with no retry.
 */
const NotFound = (): ReactNode => (
  <ErrorPageComponent withHeader />
)

export default NotFound
